module.exports = __webpack_public_path__ + "img/jg8.207e6eb1.png";